<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="card-swiper-title" :field="fields?.title" tag="h2" />
      <div class="card-swiper-list" v-if="fields?.list?.length > 0">
        <div v-for="item in fields?.list" :key="item?.id" class="card-swiper-list-item">
          <JssRichText class="card-swiper-list-item-title" :field="item?.fields?.title" tag="h3" />
          <JssRichText class="card-swiper-list-item-subtitle" :field="item?.fields?.subtitle" />
          <JssRichText class="card-swiper-list-item-desc" :field="item?.fields?.desc" />
          <JssRichText class="card-swiper-list-item-leads" :field="item?.fields?.leads" />
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'CardSwiper',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'card-swiper'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.card-swiper {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-list {
    background: #f6faf9;
    padding: 30px;
    border-radius: 16px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: stretch;

    &-item {
      padding: 24px;
      border-radius: 16px;
      background: $white;
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;

      &-title {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
        color: $grey-black;
      }

      &-subtitle {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
        color: $blue-night;
      }

      &-desc {
        background: rgba($blue-night, 0.1);
        padding: 16px 12px;
        font-size: 14px;
        line-height: 1.2;
        color: $grey-black;
        overflow-y: auto;
        flex: 1;

        li + li {
          margin-top: 6px;
        }
      }

      &-leads {
        font-size: 18px;
        line-height: 1.2;
        color: $grey-black;
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-list {
      flex-direction: row;
    }
  }
}
</style>
